import type { ButtonHTMLAttributes, MouseEvent } from "react";
import { forwardRef } from "react";

import clsx from "clsx";

import * as css from "./ButtonV2.module.css";

type ButtonAppearanceV2 =
    | "magentaAppearance"
    | "darkBlueRoundAppearance"
    | "darkBueWithMagentaHoverAppearance"
    | "magentaRoundAppearance"
    | "transparentMagentaAppearance"
    | "transparentDarkBlueAppearance"
    | "transparentLightBlueAppearance"
    | "transparentRoundMagentaBorderAppearance"
    | "transparentRoundGrayBorderAppearance"
    | "disabledAppearance";

export type IButtonV2 = ButtonHTMLAttributes<HTMLButtonElement> & {
    appearance?: ButtonAppearanceV2;
};

const ButtonV2 = forwardRef<HTMLButtonElement, IButtonV2>(
    ({ appearance = "magentaAppearance", onClick, type = "button", className, ...all }, ref) => {
        const onSubmitClick =
            type !== "submit"
                ? (ev: MouseEvent<HTMLButtonElement>) => {
                      ev.preventDefault();
                      ev.stopPropagation();
                      if (onClick) {
                          onClick(ev);
                      }
                  }
                : onClick;

        return (
            <button
                {...all}
                ref={ref}
                className={clsx(css.buttonV2Component, css[appearance!], className)}
                type={type}
                onClick={onSubmitClick}
            />
        );
    },
);

export default ButtonV2;
